import { useState } from 'react';
import { Outlet, useLocation } from 'react-router';
import { Sidebar } from './sidebar';
import { TopBar } from './top-bar';
import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet';

const pageTitles: Record<string, string> = {
  '/': 'Dashboard',
  '/students': 'Students',
  '/assignments': 'Assignments',
  '/seeds': 'Seeds Catalog',
  '/practice-sessions': 'Practice Sessions',
  '/ai-interactions': 'AI Interactions',
  '/invitations': 'Invitations',
  '/teachers': 'Teachers',
  '/settings': 'Settings',
};

export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const basePath = '/' + (location.pathname.split('/')[1] ?? '');
  const title = pageTitles[basePath] ?? 'Dashboard';

  return (
    <div className="flex min-h-screen">
      {/* Desktop sidebar */}
      <aside className="hidden w-60 shrink-0 border-r lg:block">
        <Sidebar />
      </aside>

      {/* Mobile sidebar */}
      <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
        <SheetContent side="left" className="w-60 p-0">
          <SheetTitle className="sr-only">Navigation</SheetTitle>
          <Sidebar onNavigate={() => setSidebarOpen(false)} />
        </SheetContent>
      </Sheet>

      {/* Main content */}
      <div className="flex flex-1 flex-col">
        <TopBar title={title} onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
